import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Button, Divider, Link, Paper, TextField, Typography } from '@mui/material'
import karmaStyles from '../../../styles/KarmaPool.module.css'
import DashboardLogoutFooterComponent from '../footer/DashboardLogoutFooterComponent';
import AdminDashboardMenuHeaderComponent from './header/AdminDashboardMenuHeaderComponent';
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';

function AdminDashboardRegistrationCodes() {

    function RedirectIfNotLoggedIn() {
        if (window.localStorage.getItem("jwtAuthToken") == null) {
            window.location.href = "/karma";
        }
    }

    const karmaContext = useKarmaPoolContext();

    const [addingCodeResponse, setAddingCodeResponse] = useState("");

    const [newRegistrationCode, setNewRegistrationCode] = useState("ABC-123");

    const [usedRegistrationCodes, setUsedRegistrationCodes] = useState([]);

    const [activeRegistrationCodes, setActiveRegistrationCodes] = useState([]);

    const [usesLeft, setUsesLeft] = useState(1);


    useEffect(() => {
        fetch(karmaContext.getURLBasePath() + 'admin/usedRegistrationCodes', {
            method: 'GET',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
                if (response.status !== 200) {
                    return null;
                }
                return response.json()
            })
            .then((data) => {
                if (data === null) {
                    return;
                }
                // get response code
                console.log(data);
                setUsedRegistrationCodes(data);
            })
            .catch((err) => {
                console.log(err.message);
            });

        fetch(karmaContext.getURLBasePath() + 'admin/activeRegistrationCodes', {
            method: 'GET',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => {
                if (response.status !== 200) {
                    return null;
                }
                return response.json()
            })
            .then((data) => {
                if (data === null) {
                    return;
                }
                // get response code
                console.log(data);
                setActiveRegistrationCodes(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);


    useEffect(() => {
        setNewRegistrationCode(karmaContext.local.pool.gbpInPool);
    }, [karmaContext.local]);

    const handleRegistrationCodeChange = (event) => {
        setNewRegistrationCode(event.target.value);
    };

    const handleUsesLeftChange = (event) => {
        setUsesLeft(event.target.value);
    };

    const handleSubmit = (event) => {
        // Prevent page reload
        event.preventDefault();

        console.log("Adding new registration code" + newRegistrationCode);

        fetch(karmaContext.getURLBasePath() + 'admin/registrationCode', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "code": newRegistrationCode,
                "usesLeft": usesLeft
            })
        })
            .then((response) => {
                if (response.status !== 200) {
                    setAddingCodeResponse("FAILED");
                    return null;
                }
                response.json()
            })
            .then((data) => {
                if (data === null) {
                    return;
                }
                // get response code
                console.log(data);
                setAddingCodeResponse("SUCCESS");
                karmaContext.refresh();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    const handleDelete = (code) => {
        console.log("Deleting registration code" + code);

        fetch(karmaContext.getURLBasePath() + 'admin/registrationCode/' + code, {
            method: 'DELETE',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
        })
            .then((response) => {
                if (response.status !== 200) {
                    setAddingCodeResponse("FAILED");
                    return null;
                }
                response.json()
            })
            .then((data) => {
                if (data === null) {
                    return;
                }
                // get response code
                console.log(data);
                setAddingCodeResponse("SUCCESS");
                karmaContext.refresh();
            })
            .catch((err) => {
                console.log(err.message);
            });
    }


    RedirectIfNotLoggedIn();

    return (
        <>
            <Box className={karmaStyles.homepageBox}>
                <AdminDashboardMenuHeaderComponent
                    registrationCodesEnabled={true} />
                <Box sx={{ paddingRight: "1.0rem", paddingLeft: "1.0rem", }}>
                    <Typography variant="body2" component="div" gutterBottom>
                        Admin - Registration Codes
                    </Typography>

                    <Box>
                        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                            <div>
                                <Box sx={{ display: "flex", justifyContent: "center", marginLeft: "65px" }}>
                                    <TextField
                                        sx={{
                                            margin: "0.25rem",
                                            width: "11rem", input: { color: 'white' },
                                            label: { color: 'white' }
                                        }}
                                        id="registrationCode"
                                        label="Add new code"
                                        defaultValue={newRegistrationCode}
                                        variant='filled'
                                        onChange={handleRegistrationCodeChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "center", marginLeft: "65px" }}>
                                    <TextField
                                        sx={{
                                            margin: "0.25rem",
                                            width: "11rem", input: { color: 'white' },
                                            label: { color: 'white' }
                                        }}
                                        id="usesLeft"
                                        label="How many uses to patch"
                                        defaultValue={usesLeft}
                                        variant='filled'
                                        onChange={handleUsesLeftChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Box>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="info"
                                    size="small"
                                    sx={{ backgroundColor: 'rgba(232, 232, 232, 0.5)', marginTop: "0.25rem", marginBottom: "0.75rem" }}>
                                    Create
                                </Button>
                            </div>
                            <Typography variant="body2" component="div" gutterBottom color={addingCodeResponse === "SUCCESS" ? "green" : "red"}>
                                {addingCodeResponse}
                            </Typography>
                        </form>
                        <Paper sx={{ marginTop: "0.75rem" }} />
                        <Box sx={{ display: "flex", justifyContent: "center" }} >
                            <Divider variant='middle' sx={{ bgcolor: "rgba(221, 221, 221, 0.875)", width: "12rem" }} />
                        </Box>
                        <Paper sx={{ marginTop: "1.25rem" }} />
                        <Box sx={{ display: "flex", justifyContent: "center" }} >
                            <Typography variant="body2">
                                <strong>Active Codes:</strong>
                                <Paper sx={{ marginTop: "0.25rem" }} />
                                {activeRegistrationCodes === [] ? null : activeRegistrationCodes.map((code) => (
                                    <>
                                        <Paper sx={{ marginTop: "0.75rem" }} />
                                        <Typography variant="body2">
                                            {code.registrationCode} <br />
                                            {"Uses left => "}{code.usesLeft} {" "}
                                            <Link href="#" onClick={() => handleDelete(code.registrationCode)}>
                                                <strong>(delete)</strong>
                                            </Link>
                                        </Typography>
                                    </>
                                ))}
                            </Typography>
                        </Box>
                        <Paper sx={{ marginTop: "1.25rem" }} />
                        <Box sx={{ display: "flex", justifyContent: "center" }} >
                            <Typography variant="body2">
                                <strong>Used Codes:</strong>
                                <Paper sx={{ marginTop: "0.25rem" }} />
                                {usedRegistrationCodes === [] ? null : usedRegistrationCodes.map((code) => (
                                    <>
                                        <Paper sx={{ marginTop: "0.25rem" }} />
                                        <Typography variant="body2">
                                            {code.registrationCode} .. user created -> {code.usedBy}
                                        </Typography>
                                    </>
                                ))}
                            </Typography>
                        </Box>
                    </Box>

                </Box>
            </Box>
            <DashboardLogoutFooterComponent />
        </>
    );
}

export default AdminDashboardRegistrationCodes;
